export default function hyphenateToCamel(str) {
  if (typeof str !== 'string') {
    return str
  }

  return str.replace(/-(\w)/g, (a, b) => b.toUpperCase())
}
